import { Controller } from 'react-hook-form';
import { DateInput, DateInputSize, InputSize, InputText } from '@ui/src';
import InfoRow from '../../common/info-row';
import StepPartBlock from '../../common/step-part-block';
import { NewApplicationStatus } from '../../../../hoc/common/types';
import { AdditionalInformationBlockTypes } from './types';

const LicenseAndRegistration = ({
  applicationScheme,
  questionnarieControl,
  questionnarieClearErrors,
  questionnarieErrors,
  isEditable,
  status,
}: AdditionalInformationBlockTypes) => (
  <StepPartBlock title="Licenses and registration">
    <>
      {applicationScheme?.typeOfBusinessLicenceActive && (
        <InfoRow
          title="Type of business licence? (API, SPI, EMI, OTHER)"
          id="typeOfBusinessLicence"
          lessPadding
        >
          <Controller
            control={questionnarieControl}
            name="typeOfBusinessLicence"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <InputText
                name="typeOfBusinessLicence"
                placeholder="Enter type..."
                value={value}
                onChange={(e) => {
                  onChange(e);
                  questionnarieClearErrors(['typeOfBusinessLicence']);
                }}
                size={InputSize.SMALL}
                className="borderless"
                error={questionnarieErrors?.typeOfBusinessLicence?.message}
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
              />
            )}
          />
        </InfoRow>
      )}
      {applicationScheme?.hmrcMlrNumberActive && (
        <InfoRow title="HMRC MLR number" id="hmrcMlrNumber" lessPadding>
          <Controller
            control={questionnarieControl}
            name="hmrcMlrNumber"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <InputText
                name="hmrcMlrNumber"
                placeholder="Enter number..."
                value={value}
                onChange={(e) => {
                  onChange(e);
                  questionnarieClearErrors(['hmrcMlrNumber']);
                }}
                size={InputSize.SMALL}
                className="borderless"
                error={questionnarieErrors?.hmrcMlrNumber?.message}
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
              />
            )}
          />
        </InfoRow>
      )}
      {applicationScheme?.hmrcRegistrationExpiryDateActive && (
        <InfoRow
          title="HMRC expiry date"
          id="hmrcRegistrationExpiryDate"
          lessPadding
        >
          <Controller
            control={questionnarieControl}
            name="hmrcRegistrationExpiryDate"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <DateInput
                placeholder="Select expiry date..."
                value={value}
                onChange={(e) => {
                  onChange(e);
                  questionnarieClearErrors(['hmrcRegistrationExpiryDate']);
                }}
                size={DateInputSize.SMALL}
                error={questionnarieErrors?.hmrcRegistrationExpiryDate?.message}
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
                withoutCustomSelector
                borderless
              />
            )}
          />
        </InfoRow>
      )}
      {applicationScheme?.fcaNumberActive && (
        <InfoRow title="FCA number" id="fcaNumber" lessPadding>
          <Controller
            control={questionnarieControl}
            name="fcaNumber"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <InputText
                name="fcaNumber"
                placeholder="Enter FCA number..."
                value={value}
                onChange={(e) => {
                  onChange(e);
                  questionnarieClearErrors(['fcaNumber']);
                }}
                size={InputSize.SMALL}
                className="borderless"
                error={questionnarieErrors?.fcaNumber?.message}
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
              />
            )}
          />
        </InfoRow>
      )}
      {applicationScheme?.icoNumberActive && (
        <InfoRow title="ICO number" id="icoNumber" lessPadding>
          <Controller
            control={questionnarieControl}
            name="icoNumber"
            defaultValue=""
            render={({ field: { onChange, value } }) => (
              <InputText
                name="icoNumber"
                placeholder="Enter ICO number..."
                value={value}
                onChange={(e) => {
                  onChange(e);
                  questionnarieClearErrors(['icoNumber']);
                }}
                size={InputSize.SMALL}
                className="borderless"
                error={questionnarieErrors?.icoNumber?.message}
                tabIndex={
                  !isEditable &&
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                    ? -1
                    : 0
                }
                disabled={
                  !isEditable ||
                  Boolean(
                    status === NewApplicationStatus.ACCEPTED ||
                    status === NewApplicationStatus.DECLINED,
                  )
                }
              />
            )}
          />
        </InfoRow>
      )}
    </>
  </StepPartBlock>
);

export default LicenseAndRegistration;
